import { StyledIcon } from 'fitify-ui/src/Icon'
import { colors } from 'fitify-ui/src/theme/colors'
import { phone, tabletPortrait } from 'fitify-ui-landing/src/theme/breakpoints'
import { zIndexes } from 'fitify-ui-landing/src/theme/zIndexes'
import Link from 'next/link'
import styled, { css } from 'styled-components'

import { StyledContainer } from '@/components/Container/Container.Styled'

import { NavigationVariant } from './NavigationMenu'

export const NAVIGATION_HEIGHT = 72 // px

export const StyledNavigation = styled.div`
  position: sticky;
  z-index: ${zIndexes.navigation};
  top: 0;
  width: 100%;
  backdrop-filter: blur(24px);
  background: ${colors.Mantis400};
`

export const StyledNavigationContainer = styled(StyledContainer)`
  display: flex;
  width: 100%;
  height: ${NAVIGATION_HEIGHT}px;
  align-items: center;
  justify-content: space-between;
`

export const StyledNavigationList = styled.ul<{ $variant: NavigationVariant }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;

  ${({ $variant }) => {
    if ($variant === NavigationVariant.FOOTER) {
      return css`
        flex-direction: column;
        align-items: flex-start;
      `
    }

    if ($variant === NavigationVariant.MOBILE) {
      return css`
        flex-direction: column;
        align-items: flex-start;
      `
    }

    if ($variant === NavigationVariant.COPY) {
      return css`
        margin-top: 24px;
        gap: 8px;
      `
    }

    return null
  }}
`

export const StyledNavigationLogoLink = styled(Link)`
  display: flex;
`
export const StyledBadgeWrapper = styled.div`
  display: flex;
  gap: 8px;

  ${StyledIcon} {
    width: auto;
    height: 40px;
  }

  ${phone(css`
    display: none;
  `)}
`

export const StyledNavigationLink = styled.li<{
  $variant: NavigationVariant
  $active: boolean
  $isHiddenOnMobile: boolean
}>`
  width: fit-content;
  font-family: 'Graphik LCG Web', sans-serif;
  font-style: normal;
  font-weight: 500;

  a {
    outline: none;

    span {
      border-bottom: 1px solid transparent;

      &:hover {
        border-bottom-color: ${colors.Black};
      }
    }
  }

  ${StyledIcon} {
    top: 4px;
    margin-right: 16px;
  }

  ${(props) =>
    props.$isHiddenOnMobile &&
    css`
      ${tabletPortrait(css`
        display: none;
      `)}
    `}

  ${({ $variant, $active }) => {
    if ($variant === NavigationVariant.MOBILE) {
      return css`
        color: ${colors.Gray600};
        font-size: 24px;

        a > svg {
          color: ${colors.Black};
        }

        a:hover {
          color: ${colors.Black};

          span {
            border-bottom-color: ${colors.Black};
          }

          svg {
            color: ${colors.Teal400};
          }
        }
      `
    }

    if ($variant === NavigationVariant.FOOTER) {
      return css`
        color: ${colors.White};
        font-size: 24px;

        a > svg {
          color: ${colors.White};
        }

        a:hover {
          color: ${colors.Teal400};

          span {
            border-bottom-color: ${colors.Teal400};
          }

          svg {
            color: ${colors.Teal400};
          }
        }
      `
    }

    if ($variant === NavigationVariant.COPY) {
      return css`
        padding-right: 8px;
        border-right: 1px solid ${colors.Gray600};
        color: ${colors.Gray600};
        font-size: 14px;
        font-weight: 400;
        line-height: 140%;

        &:last-child {
          border-right: none;
        }

        &:hover {
          a span {
            border-bottom-color: ${colors.White};
            color: ${colors.White};
          }
        }
      `
    }

    return css`
      color: ${colors.Gray600};
      line-height: 120%;

      &:hover {
        a {
          color: ${colors.Black};
        }
      }

      ${$active &&
      css`
        color: ${colors.Black};
      `}
    `
  }}
`

// MODAL
export const StyledNavigationMobileContainer = styled.div`
  display: none;

  ${tabletPortrait(css`
    display: initial;
  `)}
`

export const StyledNavigationMobile = styled(StyledContainer)`
  padding-top: 12px;
`

export const StyledNavigationMenu = styled.div`
  padding-top: 64px;
  margin-top: 78px;
`

export const StyledNavigationButton = styled.div`
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }
`
